export const config = {
  baseUrl: process.env.NODE_ENV === 'production' ? "lmk.chat" : 'dev.lmk.chat',
  androidAPPUrl: process.env.NODE_ENV === 'production' ? "https://play.google.com/store/apps/details?id=com.lightspace.lmk" : "https://play.google.com/store/apps/details?id=com.lightspace.lmk.dev",
  // iOSAPPUrl: "https://dynamiclinks.lmk.chat/1B33",
  iOSAPPUrl: "https://apps.apple.com/app/lmk-make-new-friends/id1463320976",
  iOSBundleId: process.env.NODE_ENV === 'production' ? "com.lightspace.lmk" : 'com.lightspace.lmk.dev',
  iOSStoreId: process.env.NODE_ENV === 'production' ? "1463320976" : '1468065101',
  androidPackageName: process.env.NODE_ENV === 'production' ? "com.lightspace.lmk" : 'com.lightspace.lmk.dev',
};



// WEBPACK FOOTER //
// src/config.js